<template>
  <div v-if="internalValue" id="consultant-edit">
    <div class="vx-row w-full">
      <div class="vx-col w-full md:w-1/2">
        <div class="vx-row w-full mt-8">
          <div class="vx-col w-full">
            <h2>Einstellungen</h2>
          </div>
          <div class="vx-col w-full">
            <DataInput
              v-if="
                !own || $store.getters['user/hasPermission']('user_management')
              "
              v-model="internalUserValue.active"
              :value="internalUserValue.active"
              type="bool"
              class="mt-4 pr-3"
              label="Aktiv"
              name="active"
            />
          </div>
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-if="
                !own || $store.getters['user/hasPermission']('user_management')
              "
              v-model="internalUserValue.groupID"
              :initial-value="internalUserValue.group"
              type="model"
              validation-rules="required"
              required
              class="w-full mt-4"
              label="Benutzergruppe"
              name="group"
              gql-query="userGroups"
            />
          </div>
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-if="
                !own || $store.getters['user/hasPermission']('user_management')
              "
              v-model="internalUserValue.roleIDs"
              :initial-value="internalUserValue.roles"
              type="model"
              validation-rules="required"
              required
              class="w-full mt-4"
              label="Rolle"
              name="role"
              multiple
              gql-query="userRoles"
            />
          </div>
          <div class="vx-col w-full">
            <DataInput
              v-if="
                !own || $store.getters['user/hasPermission']('user_management')
              "
              v-model="internalUserValue.accessGroupIDs"
              :initial-value="internalUserValue.groupAccess"
              type="model"
              class="w-full mt-4"
              label="Gruppen Zugriff"
              name="group-access"
              multiple
              gql-query="userGroups"
            />
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-model="internalUserValue.username"
              class="w-full mt-4"
              label="Benutzername"
              name="username"
            />
          </div>
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-model="internalUserValue.email"
              required
              class="w-full mt-4"
              label="E-Mail"
              name="email"
            />
          </div>
          <div v-if="!internalUserValue.id" class="vx-col w-full md:w-1/2">
            <DataInput
              v-model="internalUserValue.sendPassword"
              class="w-full mt-4"
              type="bool"
              label="Passwort senden"
              name="sendPassword"
            />
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-if="own"
              v-model="internalUserValue.oldPassword"
              :required="internalUserValue.password"
              class="w-full mt-4"
              label="Altes Passwort"
              name="oldPassword"
              type="password"
            />
          </div>
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-if="own"
              v-model="internalUserValue.password"
              class="w-full mt-4"
              label="Neues Passwort"
              name="password"
              type="password"
            />
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-model="internalValue.departmentID"
              :initial-value="internalValue.department"
              type="model"
              validation-rules="required"
              required
              class="w-full mt-4"
              label="Abteilung"
              name="department"
              model-label="
                name
                branchOffice"
              :select-label="
                el =>
                  el.branchOffice ? el.name + ' - ' + el.branchOffice : el.name
              "
              gql-query="departments"
            />
          </div>
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-model="internalValue.position"
              class="w-full mt-4"
              label="Position"
              name="position"
            />
          </div>
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-model="internalValue.telephoneOffice"
              type="tel"
              class="w-full mt-4"
              label="Telefon Zentrale"
              name="telephoneOffice"
            />
          </div>
        </div>
        <div class="vx-row w-full mb-4">
          <div class="vx-col w-full">
            <DataInput
              v-model="internalValue.street"
              class="w-full mt-4"
              label="Straße"
              name="street"
            />
          </div>
          <div class="vx-col w-full md:w-1/4">
            <DataInput
              v-model="internalValue.zip"
              class="w-full mt-4"
              label="PLZ"
              name="zip"
            />
          </div>
          <div class="vx-col w-full md:w-3/4">
            <DataInput
              v-model="internalValue.city"
              class="w-full mt-4"
              label="Stadt"
              name="city"
            />
          </div>
        </div>
      </div>
      <div class="vx-col w-full md:w-1/2">
        <div class="vx-row w-full mt-8">
          <div class="vx-col w-full">
            <h2>Firmen- und Personendaten</h2>
          </div>
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-model="internalValue.company"
              class="w-full mt-4"
              label="Firma"
              name="company"
            />
          </div>
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-model="internalValue.website"
              class="w-full mt-4"
              label="Internet"
              name="website"
            />
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-model="internalValue.salutation"
              required
              type="select"
              :options="salutations"
              class="w-full mt-4"
              label="Anrede"
              name="salutation"
            />
          </div>
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-model="internalValue.title"
              class="w-full mt-4"
              label="Titel"
              name="title"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalValue.firstName"
              required
              class="w-full mt-4"
              label="Vorname"
              name="firstName"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalValue.lastName"
              required
              class="w-full mt-4"
              label="Nachname"
              name="lastName"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalValue.shorthandSymbol"
              class="w-full mt-4"
              label="Kürzel"
              name="shorthandSymbol"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalValue.l1OperatorShorthand"
              class="w-full mt-4"
              label="L1 Kürzel"
              name="l1OperatorShorthand"
            />
          </div>
        </div>
        <div class="vx-row w-full mb-3">
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalValue.telephone"
              type="tel"
              class="w-full mt-4"
              label="Telefon Durchwahl"
              name="telephone"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalValue.telephoneMobile"
              type="tel"
              class="w-full mt-4"
              label="Mobil"
              name="telephoneMobile"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalValue.fax"
              class="w-full mt-4"
              label="Fax"
              name="fax"
            />
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              v-model="internalValue.imageID"
              public-file
              type="image"
              label="Bild"
              name="imageID"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import salutations from "@/data/enums/Salutation.js";
import projectState from "@/data/enums/ProjectState.js";

export default {
  components: {
    DataInput
  },
  props: {
    own: { type: Boolean, default: false },
    value: { type: Object, required: true },
    userValue: { type: Object, required: true }
  },
  data: () => ({
    projectState,
    salutations,
    active: true
  }),
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    internalUserValue: {
      get() {
        return this.userValue;
      },
      set(val) {
        this.$emit("userInput", val);
      }
    }
  },
  watch: {
    internalValue: {
      deep: true,
      handler: function(v) {
        this.internalValue = v;
      }
    },
    internalUserValue: {
      deep: true,
      handler: function(v) {
        this.internalUserValue = v;
      }
    }
  }
};
</script>
